export default __webpack_public_path__ + "assets/images/24d077b294b9526ef7c236d2d8b0edef.png";